import React, { useEffect, useState } from "react";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Popup from "../../../components/common/model/Popup";
import Notification from "../../../components/common/notification/Notification";
import FormField from "../../../components/common/FormField";
import closeIcon from "../../../assets/closeModel.png";
import checkedIcon from "../../../assets/check-mark.png";
import deleteIcon from "../../../assets/trash.png";
import printIcon from "../../../assets/images/print.png";
import mailIcon from "../../../assets/images/email.svg";
import useStyles from "../../../components/common/model/styles";
import { taskAllFields } from "./workAllField";
import {
  addWorkDairyAction,
  deleteTaskAction,
  getEmailPdfTaskAction,
  initialTaskLocalState,
  resetNewTaskAction,
  setNewTaskAction,
  updateWorkDairyAction,
} from "../../../store/reducers/workDiarySlice";
import Validation from "../../../utils/Validation";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import ResetFormAlert from "../surveyDiary/ResetFormAlert";
import dayjs from "dayjs";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import { getAllSubUserAction } from "../../../store/reducers/subUserSlice";
import { getDefaultTaskListAction } from "../../../store/reducers/reviewSlice";
import CustomButton from "../../../components/common/button/CustomButton";
import AlertPopup from "../../../components/common/alertPopup/AlertPopup";

interface ManageTaskProps {
  open: boolean;
  onHide: () => void;
  title: string;
  selectedTask?: any;
}
const ManageTask: React.FC<ManageTaskProps> = (props) => {
  const { open, title, selectedTask } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    workDiaryData,
    newTaskLocal,
    isWorkDiarySuccess,
    isWorkDiaryUpdateSuccess,
  } = useSelector((state: any) => state?.workDiary);
    const { leadDetails } = useSelector((state: any) => state.lead);
  const { users } = useSelector((state: any) => state.subUser);
  const { userProfile } = useSelector((state: any) => state.user);
  const { defaultTaskList } = useSelector((state: any) => state.review);
  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);
  const [deleteAlertShow, setDeleteAlertShow] = useState(false);
  const [formData, setFormData] = useState(initialTaskLocalState);
  const [selectedField, setSelectedField] = useState("");
  const [fieldsToRender, setFieldsToRender] = useState(taskAllFields);

  useEffect(() => {
    dispatch(getAllSubUserAction({ status: "ACTIVE" }));
    dispatch(getDefaultTaskListAction());
  }, [dispatch, open]);

  // Update fieldsToRender with dynamic options for assigned_to and type dropdowns
  useEffect(() => {
    const defaultTaskArray = Array.isArray(defaultTaskList)
      ? defaultTaskList
      : Array.isArray(defaultTaskList?.data)
        ? defaultTaskList.data
        : [];

    const defaultTaskOptions = defaultTaskArray
      .filter((task: any) => {
        const appearsIn = String(task?.appears_in || "")
          .trim()
          .toLowerCase();
        return appearsIn === "work diary";
      })
      .map((task: any) => String(task?.name || "").trim())
      .filter(Boolean);

    const selectedTaskRecord = selectedTask
      ? workDiaryData?.find((item: any) => item.task_id === selectedTask)
      : null;


    const currentType =
      newTaskLocal?.type || formData?.type || selectedTaskRecord?.type || "";
    const hasCurrentType = defaultTaskOptions.some(
      (option: string) =>
        option?.toLowerCase?.() === currentType?.toLowerCase?.(),
    );
    const typeOptions =
      currentType && !hasCurrentType
        ? [currentType, ...defaultTaskOptions]
        : defaultTaskOptions;

    const updatedFields = taskAllFields.map((field) => {
      if (field.id === "assigned_to") {
        return {
          ...field,
          options: (users || []).map((user: any) => ({
            label: user.name,
            id: user.staff_id ?? user?.tenant_id,
          })),
        };
      }

      if (field.id === "type") {
        return {
          ...field,
          options: typeOptions,
        };
      }

      return field;
    });

    setFieldsToRender(updatedFields);
  }, [
    users,
    defaultTaskList,
    newTaskLocal?.type,
    formData?.type,
    selectedTask,
    workDiaryData,
  ]);

  useEffect(() => {
    if (userProfile) {
      setFormData((prevState: any) => ({
        ...prevState,
        assigned_to: userProfile?.staff_id ?? userProfile?.tenant_id, // Set default assigned_to to current user
        added_by: userProfile?.staff_id ?? userProfile?.tenant_id, // Set default added_by to current user
        lead_id: leadDetails?.lead?.generated_id ?? null,
        status: "Pending", // Set default status to Pending
        date: dayjs().format("YYYY-MM-DD"), // Set default date to current date
        start_time: dayjs().format("HH:mm"), // Set default start time to current time
        end_time: dayjs().add(1, "hour").format("HH:mm"), // Set default end time to 1 hour from current time
      }));

      dispatch(
        setNewTaskAction({
          ...initialTaskLocalState,
          assigned_to: userProfile?.staff_id ?? userProfile?.tenant_id,
          added_by: userProfile?.staff_id ?? userProfile?.tenant_id,
          lead_id: leadDetails?.lead?.generated_id ?? null,
          status: "Pending",
          date: dayjs().format("YYYY-MM-DD"),
          start_time: dayjs().format("HH:mm"),
          end_time: dayjs().add(1, "hour").format("HH:mm"),
        }),
      );
    }
  }, [userProfile, leadDetails]);

  useEffect(() => {
    if (
      !selectedTask ||
      !Array.isArray(workDiaryData) ||
      !workDiaryData.length
    ) {
      return;
    }

    const selectedTaskData = workDiaryData.find(
      (item: any) => item.task_id === selectedTask,
    );

    if (!selectedTaskData) return;

    setFormData(selectedTaskData);
    dispatch(setNewTaskAction(selectedTaskData));
  }, [dispatch, selectedTask, workDiaryData]);
  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation(
    {
    type: newTaskLocal?.type,
    title: newTaskLocal?.title,
    date: newTaskLocal?.date,
    location: newTaskLocal?.location,
    start_time: newTaskLocal?.start_time,
    end_time: newTaskLocal?.end_time,
  },
 // ONLY this page opts out of the "cannot be in the past" rule for
    // start_time/end_time. Every other page calling Validation(states)
    // without this 2nd argument keeps the original behaviour untouched.
    { skipPastTimeCheck: ["start_time", "end_time"] },
);

  const hideHandler = () => {
    props.onHide();
    handleClear();
    resetAllValidator();
    dispatch(resetNewTaskAction());
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  useEffect(() => {
    if (isWorkDiarySuccess || isWorkDiaryUpdateSuccess) {
      hideHandler();
    }
  }, [isWorkDiarySuccess, isWorkDiaryUpdateSuccess]);

  const [isActionCalled, setIsActionCalled] = useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        if (selectedTask) {
          dispatch(updateWorkDairyAction(newTaskLocal));
        } else {
          dispatch(addWorkDairyAction(newTaskLocal));
        }
      } else {
        console.log("API error");
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  useEffect(() => {
    if (
      selectedField === "date" ||
      selectedField === "start_time" ||
      selectedField === "end_time"
    ) {
      resetValidator("date");
      resetValidator("start_time");
      resetValidator("end_time");
      checkValidator("date");
      checkValidator("start_time");
      checkValidator("end_time");
      setSelectedField("");
    }
  }, [selectedField]);

  const handleInputChange = (field: string, value: any) => {
    // If the field is related to time, format it as hh:mm:ss using dayjs
    if (field === "start_time" || field === "end_time") {
      // Ensure the time has a valid format like '11:00'
      const formattedTime =
        value && dayjs(value, "HH:mm").format("HH:mm:ss") !== "Invalid Date"
          ? dayjs(value, "HH:mm").format("HH:mm:ss")
          : null;

      value = formattedTime; // Update the value with formatted time
    }

    // setFormData((prevState) => ({
    //   ...prevState,
    //   [field]: value,
    // }));

    dispatch(
      setNewTaskAction({
        ...newTaskLocal,
        [field]: value,
      }),
    );

    resetValidator(field);
    setSelectedField(field);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  const handleClear = () => {
    let resetState = { ...initialTaskLocalState };
    if (newTaskLocal?.task_id) {
      dispatch(setNewTaskAction(formData));
    } else {
      dispatch(setNewTaskAction(resetState));
    }
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    resetAllValidator();
    setIsClickReset(false);
    setAlertModelShow(false);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  const handlePrintBox = () => {
    if (newTaskLocal?.task_id) {
      const printData = {
        taskId: newTaskLocal?.task_id,
        actionType: "print_boxes",
      };
      dispatch(getEmailPdfTaskAction(printData));
    }
  };

  const handleSendEmailBox = () => {
    if (newTaskLocal?.task_id) {
      const printData = {
        taskId: newTaskLocal?.task_id,
        actionType: "email",
      };
      dispatch(getEmailPdfTaskAction(printData));
    }
  };

  const handleDeleteModelOpen = () => {
    setDeleteAlertShow(true);
  };
  const handleTaskDelete = () => {
    if (newTaskLocal?.task_id) {
      const deleteData = {
        taskId: newTaskLocal?.task_id,
      };
      dispatch(deleteTaskAction(deleteData));
    }
  };

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"md"}
        popupBg="#fff"
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <>
              {newTaskLocal?.task_id &&
                newTaskLocal?.type?.toLowerCase() === "box delivery" && (
                  <img
                    onClick={handlePrintBox}
                    src={printIcon}
                    className={classes.printicons}
                    alt="print"
                  />
                )}
              {newTaskLocal?.task_id && newTaskLocal?.notified_emails && (
                <img
                  onClick={handleSendEmailBox}
                  src={mailIcon}
                  className={classes.mailicons}
                  alt="mail"
                />
              )}
              <img
                onClick={(e: any) => handleSubmit(e)}
                src={checkedIcon}
                className={classes.checkicons}
                alt="save"
              />
              <img
                onClick={openClearPopup}
                src={deleteIcon}
                className={classes.deleteicons}
                alt="delete"
              />
            </>

            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            {newTaskLocal?.task_id && (
              <CustomButton
                variant="outlined"
                title="Delete"
                onClick={handleDeleteModelOpen}
              />
            )}
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText>
            <>
              <Notification />
              <Grid
                container
                direction="row"
                spacing={0.5}
                rowGap={0}
                rowSpacing={0}
                sx={{
                  background: "#E5F4F1",
                  padding: "10px !important",
                  marginTop: "10px !important",
                  borderRadius: "5px",
                  border: "1px solid #CFCFCF",
                  overflow: "hidden",
                }}
              >
                {fieldsToRender.map((field, i) => {
                  const currentFieldValue = newTaskLocal?.[field.id] ?? "";

                  const normalizedTypeValue =
                    field.id === "type" && Array.isArray(field.options)
                      ? field.options.find(
                          (option: any) =>
                            String(option || "").toLowerCase() ===
                            String(currentFieldValue || "").toLowerCase(),
                        ) || currentFieldValue
                      : currentFieldValue;

                  return (
                    <FormField
                      key={i}
                      // onPaste={(e) => e.preventDefault()}
                      onKeyDown={(event: any) => {
                        if (
                          event.keyCode === 8 ||
                          event.keyCode === 9 ||
                          event.keyCode === 37 ||
                          event.keyCode === 38 ||
                          event.keyCode === 39 ||
                          event.keyCode === 40 ||
                          event.keyCode === 18 ||
                          event.keyCode === 17 ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key,
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      {...{
                        ...field,
                        ...{
                          variant: "outlined", // Adding this variant prop
                          inSingleGridForm: true,
                          isNonMarginTop: true,
                          value: normalizedTypeValue,
                          ...((field?.id === "start_time" ||
                            field?.id === "end_time") && {
                            disablePast: true,
                          }),
                          // disabled :(field?.id==='startTime' || field?.id==='endTime') && disabledForm,
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx: {
                              height:
                                field?.id === "description" &&
                                newTaskLocal[field?.id]?.length > 36
                                  ? "auto"
                                  : field?.type === "textarea"
                                    ? "auto"
                                    : "36px",
                              padding:
                                field?.id === "description" ||
                                field?.type === "textarea"
                                  ? "4px"
                                  : "",
                            },
                            autocomplete: "user-new-field",
                          },

                          minDate:
                            field.id === "end_time"
                              ? newTaskLocal?.start_time &&
                                newTaskLocal?.start_time
                              : undefined,
                          minTime:
                            field.id === "end_time"
                              ? newTaskLocal?.start_time &&
                                newTaskLocal?.start_time
                              : undefined,
                          minRows: field.id === "description" ? 3 : 1,
                          onBlur: onBlurAction,
                          selectedValues: newTaskLocal[field?.id],
                          onChange: (e: any) =>
                            handleInputChange(field.id, e.target.value), // Call onChange prop
                          error: error && error[field?.id],
                          helperText:
                            field?.id === "start_time" ||
                            field?.id === "end_time"
                              ? error && error[field?.id]
                              : "",
                        },
                      }}
                    />
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>

      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}

      {deleteAlertShow && (
        <AlertPopup
          open={deleteAlertShow}
          title={"Alert"}
          content={"Are you sure you want to delete this task?"}
          submitHandler={handleTaskDelete}
          onHide={() => setDeleteAlertShow(false)}
        />
      )}
    </>
  );
};

export default ManageTask;
